import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/header";

import { useNavigate } from "react-router-dom";
import {
    FaEye,
    FaEdit,
    FaTrash
} from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import "./hrdashboard.css";

const HrDashboard = () => {
    const [schemeList, setSchemeList] = useState([]);
    const [employeeCount, setEmployeeCount] = useState(0);
       const [employeeList, setEmployeeList] = useState([]);
    const [submittedEmployees, setSubmittedEmployees] = useState([]);
    const [user, setUser] = useState(null);
    const [claims, setClaims] = useState([]);
    const [loadingSchemes, setLoadingSchemes] = useState(false);
    const [policies, setPolicies] = useState([]);
    const [loadingPolicies, setLoadingPolicies] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [categories, setCategories] = useState([]);
    const employeesToDisplay = submittedEmployees.length > 0 ? submittedEmployees : employeeList;
    const [showFirstLoginPopup, setShowFirstLoginPopup] = useState(false);

    const orgId = localStorage.getItem("org_id"); 

    const navigate = useNavigate();
    useEffect(() => {
        const storedUser = localStorage.getItem("loggedUser");
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);

            // ✅ Log full user details in console
            console.log("🔍 Logged User Details:", parsedUser);
        }
    }, []);
    
    // 🔹 Fetch all schemes
    useEffect(() => {
        const fetchSchemes = async () => {
            setLoadingSchemes(true);
            try {
                // ✅ Use your correct working API
                const res = await fetch("/api/setup/getAllSchemes");
                const data = await res.json();

                if (data.success && Array.isArray(data.rows)) {
                    setSchemeList(data.rows);
                } else {
                    console.warn("No schemes found or invalid format:", data);
                    setSchemeList([]);
                }
            } catch (err) {
                console.error("Error fetching schemes:", err);
            } finally {
                setLoadingSchemes(false);
            }
        };
        fetchSchemes();
    }, []);
    // 🔹 Delete scheme
    const handleDelete = async (scheme_id) => {
        if (!window.confirm("Are you sure you want to delete this scheme?")) return;

        try {
            const response = await fetch(
                `/api/schemes/${scheme_id}`,
                { method: "DELETE" }
            );
            if (response.ok) {
                alert("Scheme deleted successfully!");
                setSchemeList((prev) => prev.filter((s) => s.scheme_id !== scheme_id));
            } else {
                alert("Failed to delete scheme.");
            }
        } catch (err) {
            console.error("Error deleting scheme:", err);
            alert("Error deleting scheme.");
        }
    };

    const getEmployeeSummary = (employeeList) => {
        const summaryMap = {};

        employeeList.forEach((emp) => {
            const key = emp.cat_org_custom_name || "Uncategorized";

            if (!summaryMap[key]) {
                summaryMap[key] = 0;
            }

            summaryMap[key]++;
        });

        return Object.entries(summaryMap).map(([name, count]) => ({
            cat_org_custom_name: name,
            count: count,
        }));
    };

    // 🔹 Fetch employee count
    useEffect(() => {
        const fetchEmployeeCount = async () => {
            try {
                const storedUser = JSON.parse(localStorage.getItem("user"));
                if (!storedUser || !storedUser.org_id) {
                    setEmployeeCount(0);
                    return;
                }

                const orgId = storedUser.org_id;

                const res = await fetch(
                    `/api/dashboard/employeeCount?org_id=${orgId}`
                );

                const data = await res.json();

                if (data.success) {
                    setEmployeeCount(data.totalEmployees);
                }
            } catch (err) {
                console.error("Error fetching employee count:", err);
            }
        };

        fetchEmployeeCount();
    }, []);

   
    useEffect(() => {
        const fetchPolicies = async () => {
            try {
                const storedUser = JSON.parse(localStorage.getItem("user"));

                if (!storedUser || !storedUser.org_id) {
                    console.error("User org_id missing!");
                    setPolicies([]);
                    return;
                }

                const orgId = storedUser.org_id;

                const res = await fetch(`/api/add_policy?org_id=${orgId}`);

                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }

                const data = await res.json();

                // Filter by org_id (if backend returns all policies)
                const filtered = Array.isArray(data)
                    ? data.filter((p) => p.org_id === orgId)
                    : [];

                setPolicies(filtered);
            } catch (err) {
                console.error("Error fetching policies:", err);
                setPolicies([]);
            } finally {
                setLoadingPolicies(false);
            }
        };

        fetchPolicies();
    }, []);
    
    const fetchCategoriesByOrg = async () => {
       const orgId = localStorage.getItem("org_id");
       if (!orgId) {
         console.error("Organization ID not found in localStorage");
         return;
       }
   
       try {
         const res = await fetch(`/api/categories/${orgId}`);
         const data = await res.json();
         if (data.success) {
           // Remove duplicates based on 'categories' field
           const uniqueCategories = [
             ...new Map(data.rows.map(item => [item.categories, item])).values()
           ];
           setCategories(uniqueCategories);
         } else {
           console.error("Failed to fetch categories:", data.message);
         }
       } catch (err) {
         console.error("Error fetching categories:", err);
       }
     };
   
     useEffect(() => {
       fetchCategoriesByOrg();
     }, []);
   

    const fetchSchemesByCategory = async (categoryName) => {
        if (!categoryName) return;
        setLoadingSchemes(true);
        try {
            const res = await fetch(`/api/schemes/${categoryName}`);
            const data = await res.json();
            if (data.success) {
                setSchemeList(data.rows);
            } else {
                console.error("Failed to fetch schemes:", data.message);
            }
        } catch (err) {
            console.error("Error fetching schemes:", err);
        } finally {
            setLoadingSchemes(false);
        }
    };

   
    // 🔹 Fetch claim requests
    useEffect(() => {
            const fetchClaims = async () => {
                try {
                    const response = await fetch(`/api/ebclaim_request?org_id=${orgId}`);
                    const data = await response.json();
    
                    const mappedData = data.map(c => ({
                        claim_req_id: c.claim_req_id,
                        emp_id: c.emp_id,
                        emp_name: c.emp_name,
                        patient_name: c.patient_name,
                        claim_type: c.claim_type,
                        hospital_name: c.hospital_name,
                        sum_insured_bal: c.sum_insured_bal,
                        claim_amount: c.claim_amount,
                        doc_fath_loc: c.doc_fath_loc,
                        claim_status: c.claim_status || 'Pending'
                    }));
    
                    setClaims(mappedData);
                } catch (error) {
                    console.error('Error fetching claims:', error);
                }
            };
    
            fetchClaims();
        }, []);
    

    return (
        <div className="hrdashboard-container">
            <aside className="sidebar">
                <Header />
            </aside>

            <main className="main-content">

                {/* Dashboard Cards */}
                <div className="dashboard-cards">
                    <div className="card">
                        <h3>Employee Member Count</h3>
                        <p>{employeeCount}</p>
                    </div>
                    <div className="card">
                        <h3>CD Balance</h3>
                    </div>
                    <div className="card">
                        <div className="employee-summary-wrapper">
                           

                            <div className="employee-summary-grid card">
                                {employeesToDisplay.length === 0 ? (
                                    <p>No employees found.</p>
                                ) : (
                                    getEmployeeSummary(employeesToDisplay).map((row, index) => (
                                        <div key={index} className="employee-summary-card">
                                            <h3>{row.cat_org_custom_name}</h3>
                                            <p>Employees: {row.count}</p>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* ✅ Claim Request List */}
                <div className="claim-request card">
                    <h4>Policies</h4>
                    <table className="policy-table">
                        <thead>
                            <tr>
                                <th>Policy Number</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Premium</th>
                                <th>GST</th>
                                <th>Total Premium</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingPolicies ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        Loading policies...
                                    </td>
                                </tr>
                            ) : policies && policies.length > 0 ? (
                                policies.map((p) => (
                                    <tr key={p.policy_id}>
                                        <td>{p.policy_number || "—"}</td>
                                        <td>{p.start_date ? new Date(p.start_date).toLocaleDateString() : "—"}</td>
                                        <td>{p.end_date ? new Date(p.end_date).toLocaleDateString() : "—"}</td>
                                        <td>{p.premium_amount ?? "—"}</td>
                                        <td>{p.gst_amount ?? "—"}</td>
                                        <td>{p.total_premium ?? "—"}</td>
                                        <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                            {/* 👁 VIEW */}


                                            {/* ✏️ EDIT */}
                                            <FontAwesomeIcon
                                                icon={faEdit}
                                                style={{ color: "#000", cursor: "pointer", marginRight: "8px" }}
                                                title="Edit"
                                                onClick={() =>
                                                    navigate("/add-policy", { state: { policy: p } })
                                                }
                                            />

                                            {/* 🗑 DELETE */}
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                style={{ color: "#000", cursor: "pointer" }}
                                                title="Delete"
                                                onClick={async () => {
                                                    if (window.confirm("Are you sure you want to delete this policy?")) {
                                                        try {
                                                            const res = await fetch(
                                                                `/api/add_policy/${p.policy_id}`,
                                                                { method: "DELETE" }
                                                            );
                                                            const data = await res.json();

                                                            if (data.success) {
                                                                setPolicies((prev) =>
                                                                    prev.filter((x) => x.policy_id !== p.policy_id)
                                                                );
                                                                alert("✅ Policy deleted successfully!");
                                                            } else {
                                                                alert("⚠️ Failed to delete policy.");
                                                            }
                                                        } catch (err) {
                                                            console.error("Error deleting policy:", err);
                                                            alert("❌ Server error while deleting.");
                                                        }
                                                    }
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        No policies found
                                    </td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>


                <div className="claim-request card">
                    <h4>Claim Request List</h4>
                    <table className="policy-table">
                        <thead>
                            <tr>
                                <th>Claim ID</th>
                                <th>Emp ID</th>
                                <th>Employee</th>
                                <th>Patient</th>
                                <th>Type</th>
                                <th>Hospital</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {claims.length > 0 ? (
                                claims.map((claim) => (
                                    <tr key={claim.claim_req_id}>
                                        <td>{claim.claim_req_id}</td>
                                        <td>{claim.emp_id}</td>
                                        <td>{claim.emp_name}</td>
                                        <td>{claim.patient_name || "-"}</td>
                                        <td>{claim.claim_type}</td>
                                        <td>{claim.hospital_name}</td>
                                        <td>₹{claim.claim_amount}</td>
                                        <td>{claim.claim_status}</td>
                                        <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                            <FontAwesomeIcon
                                                icon={faEdit}
                                                style={{ color: "#000", cursor: "pointer", marginRight: "8px" }}
                                                title="Edit"
                                            />
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                style={{ color: "red", cursor: "pointer" }}
                                                title="Delete"
                                            />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center" }}>
                                        No claim requests found.
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </main>
        </div>
    );
};

export default HrDashboard;
